import React, { useEffect } from 'react'
import Input from '../../components/Input'
import Keyboard from '../../components/Keyboard'
import CollectionsSetTS from '../../components/CollectionsSet'
import tts from '../../lib/TTS.js'
import SearchScreenHeader from './SearchScreenHeader'
import SearchScreenResult from './SearchScreenResult'
import {
  getCurrentFocusKey,
  setFocus,
} from '@noriginmedia/norigin-spatial-navigation'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import { useSearchResult } from './hooks/useSearchResult'
import cx from 'classnames'
import { useSidePanel } from '../../components/SidePanel/SidePanelProvider'
import { platformTransitionStyle } from '../../../../shared/helpers.js'

const KEYBOARD_COMPONENT_FOCUS_KEY = 'KEYBOARD_COMPONENT'
const SAVE_SEARCH_QUERY_ACTION_NAME = 'SAVE_SEARCH_QUERY'

const SearchScreen = () => {
  const searchQueryRedux = useAppSelector((state) => state.search.searchQuery)
  const dispatch = useAppDispatch()

  const { isSidePanelOpened } = useSidePanel()

  const {
    searchQueryRef,
    collectionsReady,
    searchResultCollection,
    setSearchResult,
    setInitialSearchResults,
    setNextCarouselResult,
    error,
  } = useSearchResult()

  useEffect(() => {
    !searchQueryRedux && setInitialSearchResults()
  }, [])

  useEffect(() => {
    if (searchResultCollection.length === 0 && error)
      getCurrentFocusKey() !== KEYBOARD_COMPONENT_FOCUS_KEY &&
        handleFocusBackToKeyboard()
  }, [error, searchResultCollection])

  const handleSearchCleared = () => {
    setInitialSearchResults()
    tts.addTextToRead('Search Cleared')
  }

  const handleLeftArrowExit = () => {
    dispatch({
      type: SAVE_SEARCH_QUERY_ACTION_NAME,
      payload: { searchQuery: '' },
    })
  }

  const handleFocusBackToKeyboard = () => {
    setFocus(KEYBOARD_COMPONENT_FOCUS_KEY)
  }

  const emptyCollectionResponse =
    searchResultCollection?.length === 0 && collectionsReady
  return (
    <div
      style={{
        transition: platformTransitionStyle(`transform 500ms ease-in-out`),
      }}
      className={cx('search-screen', {
        'search-screen--side-panel-closed': !isSidePanelOpened,
      })}
    >
      <SearchScreenHeader
        getSearchResults={setSearchResult}
        handleSearchCleared={handleSearchCleared}
        emptyCollectionResponse={emptyCollectionResponse}
        handleLeftArrowExit={handleLeftArrowExit}
      >
        {(searchQuery, showCursor, onEnterPress, onArrowPress) => (
          <>
            <Input searchQuery={searchQuery} showCursor={showCursor} />
            <Keyboard onArrowPress={onArrowPress} onEnterPress={onEnterPress} />
          </>
        )}
      </SearchScreenHeader>
      <SearchScreenResult
        emptyCollectionResponse={emptyCollectionResponse}
        searchError={error}
        collectionsReady={collectionsReady}
        searchQuery={searchQueryRef.current}
      >
        {collectionsReady && (
          <CollectionsSetTS
            collections={searchResultCollection}
            onLeftExit={handleFocusBackToKeyboard}
            avoidSeeAllCard={true}
            hasHeaderComponent={true}
            handleInfiniteFetching={setNextCarouselResult}
          />
        )}
      </SearchScreenResult>
    </div>
  )
}

export default SearchScreen
